// Who can sign in at this till: the active cashiers and managers of its shop,
// by name, for the lock screen to offer.
//
// Read each time a lock shows rather than once when the till starts, so a
// cashier the owner has just added can sign in without anyone reloading the
// till. A reload keeps the names it already has on screen until the answer
// comes, so the list never blinks empty.

import { api } from '../api/client';
import type { components } from '../api/types';

export type Cashier = components['schemas']['TillCashierBody'];

/** loading until the first answer; failed when the server gave none. */
export type RosterStatus = 'loading' | 'ready' | 'failed';

export class Roster {
	cashiers = $state<Cashier[]>([]);
	status = $state<RosterStatus>('loading');

	async load(): Promise<void> {
		try {
			const { data, error } = await api.GET('/api/till/me/cashiers');
			if (error === undefined && data) {
				this.cashiers = data.cashiers ?? [];
				this.status = 'ready';
				return;
			}
			this.status = 'failed';
		} catch {
			this.status = 'failed';
		}
	}
}
